import { observer } from 'mobx-react-lite';
import AppCheckBox from '@/ui/checkbox';
import Conf from '@/common/conf';
import FoldBtn from '@/ui/fold-btn';
import { SVGPureIcon } from '@/ui';
import checkStore from '@/store/checkStore';
import chatStoreManager from '@/store/chat/manager';
import { request } from '@/common';
import Other from '@/common/helper/other';
import copy from 'copy-to-clipboard';
import GenerateImg from './GenerateImg';
import { useState } from 'react';
import userStore from '@/store/user';
import navbarStore from '@/store/navbar';
import { HelperCore } from '@/common/helper';
import { toPng, toBlob }  from "html-to-image"
import { uploadBase64 } from '@/common/upload';
import globalStore from '@/store/global';
import Loader from '@/common/helper/loader';
import client from '@/store/client';
import { RobotsMap } from '@/common/localRobot.js';
import { useParams } from 'react-router-dom';
import { useMeasure } from 'react-use';
import { useMemo } from 'react';

const CheckAction = observer(props => {
  const chatStore = chatStoreManager.current;

  const [isShowImgGenerate, setIsShowImgGenerate] = useState(false)
  const [linking, setLinking] = useState(false)
  const [imging, setImging] = useState(false)
  const [img, setImg] = useState("")
  const [blob, setBlob] = useState(null)

  const [$refContainer, { width: widthContainer }] = useMeasure();
  const isSmall = useMemo(() => {
    return widthContainer < Loader.size.chatSmall;
  }, [widthContainer]);

  const { id } = useParams();

  const asstInfo = (role_id) => {
    if(globalStore.isKownledgeChat()){
      return Loader.knowledgeRobotInfo;
    }

    const info = navbarStore?.chatModels[role_id];
    let modelInfo = {};
    if(!client.isLLQ) {
      const model = navbarStore.historyList?.find(item => item.conversation_id === id);
      modelInfo = {
        ...model,
        title: model?.name,
      }
    }
    return info || RobotsMap[role_id] || modelInfo || {};
  }

  const asstIcon = (role_id) => asstInfo(role_id).dl_icon || asstInfo(role_id).icon;

  const getCheckedList = () => {
    const checkedList = checkStore.data.checkList.filter(item => item.checked)
    const messageList = chatStore.messageList.filter(item => {
      return !!checkedList.find(_item => {
        return _item.label.includes(item.msg_id)
      })
    }).map(item => {
      const is_ai_dynamic = (item.generate_type == 5 || globalStore.robotDynamicPageSo(chatStore.currAsstId)) && Loader.isDynamicPageRole(chatStore.currAsstId);
      return {
        ...item,
        botInfo: navbarStore.chatModels[item.role_id],
        is_ai_dynamic,
      }
    })
    return messageList
  }

  const generateImg = async () => {
    const messageList = getCheckedList()
    if(!messageList.length) {
      Other.toast('请选择对话', "warning")
      return
    }
    if(imging) return
    setImging(true)
    const base64 = await toPng(document.querySelector("#message-list-ul-clone"))
    const blob = await toBlob(document.querySelector("#message-list-ul-clone"))
    const url = await uploadBase64(base64, { suffix: "png" })
    setImging(false)
    setImg(url)
    setBlob(blob)
    setIsShowImgGenerate(true)
  }

  const createShare = async () => {
    console.log('chatId=======', chatStore.chatId);
    
    const messageList = getCheckedList().map(item => {
      return {
        conversation_id: chatStore.chatId,
        ...item,
        chat_type: chatStore.historyData?.chat_type,
        paramModel: {
          file: item.file
        },
        botInfo: {
          icon: chatStore.isAgent ? chatStore.agentInfo?.params?.system_info?.icon : (asstIcon(item.role_id) || 'https://p1.ssl.qhimg.com/t110b9a93018295fdd8f951fb2c.png'),
          title: asstInfo(item.role_id)?.title ||  chatStore.agentInfo?.params?.system_info?.name
        }
      }
    })

    if(!messageList.length) {
      Other.toast('请选择对话', "warning")
      return
    }
    
    if(linking) return
    setLinking(true)
    let title = chatStore.historyData?.title || '';
    const historyConversation = navbarStore.historyList.find(item => item.conversation_id == id);
    if(historyConversation){
      title = historyConversation.title;
    }
    const res = await request
    .post('/chat/share', {
      cid: chatStore.chatId,
      title,
      messages: JSON.stringify(messageList),
      username: userStore.showNickname,
      user: userStore.showIcon,
      assistant: chatStore.isAgent ? chatStore.agentInfo?.params?.system_info?.icon : (asstIcon(messageList[0].role_id) || 'https://p1.ssl.qhimg.com/t110b9a93018295fdd8f951fb2c.png')
    })
    // 区分当前环境
    const from = client.isLLQ ? "pc" : (client.isClient ? "weishi" : "web");
    const copied = copy(`https://${HelperCore.IS_ONLINE ? "n.cn": "nami.so.360.com"}/share/r1/${res.data.id}?from=${from}`);
    copied && Other.toast('复制成功', "success");
    setLinking(false)
  }

  return (
    <div className='absolute bottom-0 left-0 h-64px flex justify-center border-t-1px border-[rgba(0,0,0,0.06)] w-full bg-white' ref={$refContainer}>
      <div className='max-w-842px flex justify-between h-64px w-full px-16px'>
        <div className='flex items-center h-64px'>
          <AppCheckBox 
            className="cursor-pointer w-16px h-16px"
            onClick={() => {
              if(checkStore.data.checkList.length != chatStore.messageList.length) {
                chatStore.messageList.forEach(item => {
                  checkStore.setChecked(item.msg_id + "-p", false)
                  checkStore.setChecked(item.msg_id + "-r", false)
                })
              }
              checkStore.setAllChecked(!checkStore.data.allChecked)
              checkStore.setData({
                allChecked: !checkStore.data.allChecked
              })
            }}
            checked={checkStore.data.allChecked}
          />
          <div className='ml-8px text-14px text-black truncate'>全选</div>
          <div className='ml-16px text-[rgba(0,0,0,0.3)] truncate'>所有内容均由AI生成仅供参考</div>
        </div>
        <div className='flex items-center h-64px'>
          <FoldBtn iconName="chat_share_link" text="复制链接" className={`${linking ? "cursor-not-allowed" : ""}`} onClick={createShare} small={isSmall} iconClassName="!size-20px" />
          <FoldBtn iconName="chat_share_img" text="生成图片" className={`${imging ? "cursor-not-allowed" : ""}`} small={isSmall} iconClassName="!size-20px" onClick={() => {
            generateImg()
          }} />
          <SVGPureIcon 
            name="chat_share_close"
            className='cursor-pointer text-[rgba(0,0,0,0.5)] hover:text-[rgba(0,0,0,0.8)]' 
            size={10} 
            onClick={() => {
              checkStore.reset()
            }}
          />
        </div>
      </div>
      {
        isShowImgGenerate 
        ? <GenerateImg 
            closeCb={() => {
              setIsShowImgGenerate(false)
            }}
            img={img}
            blob={blob}
          />
        : null
      }
    </div>
  )
}) 

export default CheckAction